import { useEffect } from "react";

import { create } from "zustand";
import { Talent } from "../types";
import { STORAGE_KEYS } from "../constants";

interface CurrentTalentState {
  currentProfile: null | Talent;
  setCurrentProfile: (profile: Talent | null) => void;
  hydrated: boolean;
  setHydrated: (value: boolean) => void;
}

export const useCurrentTalentStore = create<CurrentTalentState>()((set) => ({
  currentProfile: null,
  setCurrentProfile: (profile) => set(() => ({ currentProfile: profile })),
  hydrated: false,
  setHydrated: (value) => set(() => ({ hydrated: value })),
}));

function readStoredTalentProfile(): Talent | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.ACTIVE_TALENT);
    if (!stored) return null;

    const parsed = JSON.parse(stored) as Talent | null;
    if (!parsed || typeof parsed !== "object" || !parsed.id) {
      localStorage.removeItem(STORAGE_KEYS.ACTIVE_TALENT);
      return null;
    }

    return parsed;
  } catch {
    localStorage.removeItem(STORAGE_KEYS.ACTIVE_TALENT);
    return null;
  }
}

export const useCurrentTalentProfile = () => {
  const { currentProfile, setCurrentProfile, hydrated, setHydrated } = useCurrentTalentStore();

  function SetTalentProfile(talent: Talent | null) {
    if (talent) {
      localStorage.setItem(STORAGE_KEYS.ACTIVE_TALENT, JSON.stringify(talent));
    } else {
      localStorage.removeItem(STORAGE_KEYS.ACTIVE_TALENT);
    }
    setCurrentProfile(talent);
  }

  useEffect(() => {
    if (hydrated) return;

    const storedProfile = readStoredTalentProfile();
    if (storedProfile) {
      setCurrentProfile(storedProfile);
    }
    setHydrated(true);
  }, [hydrated, setCurrentProfile, setHydrated]);

  return { currentProfile, SetTalentProfile };
};

interface AddTalentState {
  addTalent: boolean;
  setAddTalent: (profile: boolean) => void;
}

export const useAddTalent = create<AddTalentState>()((set) => ({
  addTalent: false,
  setAddTalent: (val) => set(() => ({ addTalent: val })),
}));
